import { getAssetTableColumns } from "./assetTableColumns"
import { observer } from "mobx-react"
import { useAssetListStore, useRootStore } from "contexts/RootStore.context"
import ShowMoreButton from "components/DataTable/components/ShowMoreButton"
import { DataTable } from "components/DataTable/DataTable";
import { Asset } from "types/asset";
import { AssetFlyout } from "../../AssetFlyout/AssetFlyout";
import useDevice from "hooks/useDevice";
import { MobileDataTable } from "components/DataTable/MobileDataTable";
import { MobileAssetRow } from "./MobileAssetRow";
import { useMemo } from "react";

export const AssetsDataTable = observer(() => {

  const {
    assetList, loading, nextCount, loadAssets, getEmptyListMsg, onSort,
    selectedAsset, setSelectedAsset
  } = useAssetListStore()
  const { availableFeatures } = useRootStore()
  const { isMobileDevice } = useDevice()

  const onRowClick = (row: Asset) => setSelectedAsset(row)

  const SortOptions = useMemo(() => {
    return [
      {
        title: 'Asset Name',
        sortField: 'asset_name',
      },
      {
        title: 'Asset Type',
        sortField: 'asset_type',
      },
      {
        title: 'Last Seen',
        sortField: 'last_update',
        DescTitle: 'descending',
        AscTitle: 'ascending',
      },
      {
        title: 'Status',
        sortField: 'status',
      },
      {
        title: 'Location',
        sortField: 'location',
      },
      {
        title: 'Owner',
        sortField: 'asset_owner',
      },
      {
        title: 'Battery',
        sortField: 'battery_level',
        DescTitle: 'high to low',
        AscTitle: 'low to high',
      },
    ]
  }, [])

  return (
    <>
      {isMobileDevice
        ? <MobileDataTable
          loading={loading}
          data={assetList}
          defaultSortField="last_update"
          defaultSortDirection="desc"
          emptyListMsg={getEmptyListMsg}
          onSort={onSort}
          renderLoadMore={nextCount > 0 && (
            <ShowMoreButton
              fetchFunction={() => loadAssets()}
              nextIsLoading={loading}
              nextCount={nextCount}
            />
          )}
          RowElement={row => <MobileAssetRow asset={row} onClick={onRowClick} />}
          SortOptions={SortOptions}
        />
        : <DataTable<Asset>
          loading={loading}
          columns={getAssetTableColumns(availableFeatures)}
          data={assetList}
          emptyListMsg={getEmptyListMsg}
          onSort={onSort}
          onRowClick={onRowClick}
          renderLoadMore={nextCount > 0 && (
            <ShowMoreButton
              fetchFunction={() => loadAssets()}
              nextIsLoading={loading}
              nextCount={nextCount}
            />
          )}
        />
      }
      <AssetFlyout
        onClose={() => setSelectedAsset(null)}
        asset={selectedAsset}
        onStatusUpdate={() => { loadAssets(true) }}
      />
    </>
  )
})